import { render } from "./WrapUp.vue?vue&type=template&id=2b1e26a6&scoped=true"
import script from "./WrapUp.vue?vue&type=script&lang=js"
export * from "./WrapUp.vue?vue&type=script&lang=js"

import "./WrapUp.vue?vue&type=style&index=0&id=2b1e26a6&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1e26a6"]])

export default __exports__